import { Component } from '@angular/core';

@Component({
    selector: 'kt-scroll-top',
    templateUrl: './scroll-top.component.html',
})
export class ScrollTopComponent {}
